import { DecisionStatsItem } from "./DecisionStatsItem";

export default DecisionStatsItem;